module.exports = __webpack_public_path__ + "img/book-04.a1a852a2.png";